import {Directive, TemplateRef, ViewContainerRef} from "@angular/core";

@Directive({
  selector: 'ng-template[intPortalSlotTemplate]'
})
export class IntPortalSlotTemplateDirective {
  constructor(
    readonly templateRef: TemplateRef<any>,
    readonly vcr: ViewContainerRef
  ) {}
}
